import { render, staticRenderFns } from "./Wishes.vue?vue&type=template&id=4c51d3e1&scoped=true&"
import script from "./Wishes.vue?vue&type=script&lang=js&"
export * from "./Wishes.vue?vue&type=script&lang=js&"
import style0 from "./Wishes.vue?vue&type=style&index=0&id=4c51d3e1&scoped=true&lang=scss&"
import style1 from "./Wishes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51d3e1",
  null
  
)

export default component.exports